import { useRouteError } from 'react-router'
import { InvalidSessionError } from '@/util/errors'
import { getSignInURL } from '@/util/helpers'
import { useParams } from 'react-router-dom'

export default function ErrorPage() {
  const { schoolSlug } = useParams()
  const error = useRouteError()
  if (error instanceof InvalidSessionError) {
    const signinPage = getSignInURL(schoolSlug)
    window.location.replace(signinPage)
    return null
  }

  return (
    <div className='flex flex-col items-center mx-auto py-56'>
      <div className='text-xl font-serif text-white mb-4 '>
        {' '}
        Sorry, something went wrong. Please try again later or contact support.
      </div>
    </div>
  )
}
